var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"emptyContent"},[_c('div',{staticClass:"centerWrap"},[_c('div',{staticClass:"icon"},[_c('img',{attrs:{"src":require("../assets/img/common/zan_wu_data.png")}})]),_vm._v(" "),_c('div',{staticClass:"text"},[_vm._v("暂无数据")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a6d3d646","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/common/Empty.vue
// module id = null
// module chunks = 